import * as React from "react";
import ReactStars from "react-stars";
import Button from "../../../../components/button";
import StampedContext from "../../../../StampedContext";
import styles from "./cta.module.scss";
import { staticRating } from "../../../../utils";
import PaymentSeals from "../../../../components/payment-seals";
import Testimonial from "../../../../components/testimonial";

const HeroImage = "https://res.cloudinary.com/albin-groen/image/upload/f_auto/v1585245980/ceroface/hero.png";

const Cta = () => {
  const { data, error, loading } = React.useContext(StampedContext);

  const review = data?.data[2];

  return (
    <header className={styles.cta}>
      <div className={styles.ctaContent}>
        <h1 className={styles.heading}>
          Find <span>Confidence</span> in Your Complexion
        </h1>
        <p className={styles.lede}>
          Order your <strong>ALL-IN-ONE</strong> CeroFace kit <strong>now</strong> before we run out of stock!
        </p>
        <div className={styles.buttonWrapper}>
          <Button variant="cta" href="/cart">
            RUSH MY ORDER
          </Button>

          <div className="hideOnDesktop">
            <PaymentSeals />
          </div>

          {!error && !loading && (
            <div className={styles.ratingWrapper}>
              <div className={styles.stars}>
                <h4>({data?.totalAll})</h4>
                <ReactStars
                  value={staticRating}
                  color2="#ffd203"
                  color1="#ccc"
                  count={5}
                  size={16}
                  edit={false}
                />
                <h4 className={styles.rating}>{staticRating}/5</h4>
              </div>
            </div>
          )}
        </div>

        <div className="hideOnPhone">
          <PaymentSeals />
        </div>

        <Testimonial
          dynamic
          variant="cta"
          error={error}
          loading={loading}
          review={review}
        />
      </div>

      <img className={styles.largeImage} src={HeroImage} alt="Hero" />
    </header>
  );
};

export default Cta;
